module.exports = __webpack_public_path__ + "static/media/rectangle-wide.b22668bf.svg";